module.exports = __webpack_public_path__ + "img/step52_a_printer_basic_remove_foam.a6a83d66.png";